// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `html,
body {
}

@keyframes spin {
	0% {
		transform: rotate(0deg);
	}
	100% {
		transform: rotate(360deg);
	}
}

.spinner {
	border: 4px solid rgba(0, 0, 0, 0.1);
	border-left: 4px solid #3498db;
	border-radius: 50%;
	width: 40px;
	height: 40px;
	animation: spin 1s linear infinite;
}
.small-spinner {
	border: 4px solid rgba(0, 0, 0, 0.1);
	border-left: 4px solid white;
	border-radius: 50%;
	width: 15px;
	height: 15px;
	animation: spin 1s linear infinite;
}
`, "",{"version":3,"sources":["webpack://./src/stylesheets/index.css"],"names":[],"mappings":"AAAA;;AAEA;;AAEA;CACC;EACC,uBAAuB;CACxB;CACA;EACC,yBAAyB;CAC1B;AACD;;AAEA;CACC,oCAAoC;CACpC,8BAA8B;CAC9B,kBAAkB;CAClB,WAAW;CACX,YAAY;CACZ,kCAAkC;AACnC;AACA;CACC,oCAAoC;CACpC,4BAA4B;CAC5B,kBAAkB;CAClB,WAAW;CACX,YAAY;CACZ,kCAAkC;AACnC","sourcesContent":["html,\nbody {\n}\n\n@keyframes spin {\n\t0% {\n\t\ttransform: rotate(0deg);\n\t}\n\t100% {\n\t\ttransform: rotate(360deg);\n\t}\n}\n\n.spinner {\n\tborder: 4px solid rgba(0, 0, 0, 0.1);\n\tborder-left: 4px solid #3498db;\n\tborder-radius: 50%;\n\twidth: 40px;\n\theight: 40px;\n\tanimation: spin 1s linear infinite;\n}\n.small-spinner {\n\tborder: 4px solid rgba(0, 0, 0, 0.1);\n\tborder-left: 4px solid white;\n\tborder-radius: 50%;\n\twidth: 15px;\n\theight: 15px;\n\tanimation: spin 1s linear infinite;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
